// React core components
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// Material React Pro 2 components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Context
import { AuthContext } from "context";

// Material UI Components
import { Card, Divider, Grid, Icon } from "@mui/material";

// Services
import CrudService from "services/cruds-service";
import pxToRem from "assets/theme/functions/pxToRem";
import { analytics } from "layouts/dashboards/analytics/analytics";
import { events } from "layouts/dashboards/analytics/events";

const Certificates = () => {
  const [certificates, setCertificates] = useState([]);
  const [user, setUser] = useState({});
  const { setIsAuthenticated, getCurrentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  // Function to check if the user is authenticated
  useEffect(() => {
    const start_time = Date.now();
    async function checkToken() {
      try {
        let user_id = await getCurrentUser();
        if (!user_id) {
          setIsAuthenticated(false);
          localStorage.removeItem("token");
        } else {
          setUser(user_id);
          analytics.track(events.VIEW_PAGE, { page: "my-certificates", userId: user_id });
          return user_id;
        }
      } catch (error) {
        console.error(error);
        alert("An error occurred. Please try again later.");
      }
    }
    // Function to fetch the certificates
    async function fetchCertificates(userId) {
      try {
        let response = await CrudService.getCertificates(userId);
        setCertificates(response);
      } catch (error) {
        console.error(error);
        alert("An error occurred. Please try again later.");
      }
    }
    checkToken().then((userId) => fetchCertificates(userId));
    return () => {
      checkToken().then((userId) => {
      analytics.track(events.PAGE_LEFT, { page: "my-certificates", userId: userId, start_time: start_time, end_time: Date.now() });
      });
    }
  }, []);

  // Function to download the certificate
  const downloadImage = (certificate_image, course_id) => {
    const link = document.createElement("a");
    link.href = `data:image/jpeg;base64,${certificate_image}`;
    link.download = `Certificate-${course_id}.jpg`; // You can specify the filename here
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const shareToLinkedIn = (certificateImage, courseId) => {
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      `data:image/jpeg;base64,${certificateImage}`
    )}`;
    window.open(linkedInUrl, "_blank");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDTypography variant="h3" mt={2}>
        My Certificates
      </MDTypography>
      <Divider />
      {certificates.length > 0 ? (
        <>
          <Grid container spacing={3}>
            {certificates.map((certificate, index) => (
              <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                <Card>
                  <MDBox px={2} pt={2}>
                    <img
                      src={certificate.link}
                      alt={certificate.course_id}
                      id={certificate.course_id}
                      style={{
                        width: "100%",
                        border: "10px solid",
                        borderImageSlice: 1,
                        borderImageSource:
                          "linear-gradient(to right, #00d2ff, #3a7bd5)",
                        borderRadius: "10px",
                      }}
                    />
                  </MDBox>
                  {/* <MDTypography
                    variant="h6"
                    align="center"
                    mx={2}
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {certificate.course_name}
                  </MDTypography> */}

                  <MDBox display="flex" px={1} pb={1}>
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        window.open(
                          `/showCertificate/${user}/certificate/${certificate.course_id}/${certificate.link}`
                        );
                      }}
                    >
                      View Certificate
                    </MDButton>
                    <MDButton
                      variant="text"
                      color="info"
                      onClick={() => {
                        navigate(`/course-content/${certificate.course_id}`);
                      }}
                    >
                      Go to course
                    </MDButton>
                    <MDButton
                      variant="text"
                      color="info"
                      style={{ marginLeft: "auto" }}
                    >
                      <Icon
                        onClick={() =>
                          downloadImage(
                            certificate.certificate_image,
                            certificate.course_id
                          )
                        }
                        color="error"
                      >
                        download
                      </Icon>
                    </MDButton>
                  </MDBox>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        <>
          <MDAlert severity="info" mt={2} maxHeight={pxToRem(40)}>
            Your earned certificates will show up here.
          </MDAlert>
        </>
      )}

      <MDBox mt={4} />
    </DashboardLayout>
  );
};

export default Certificates;
